/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-array-method-this-argument */
/* eslint-disable unicorn/no-array-callback-reference */
/* eslint-disable no-console */
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import Request, { ApiMode } from '../../utils/Request';
import Manipulator from '../../utils/dom/manipulator';
import dayjs from 'dayjs';

const IS_LOCAL = false;

const SELECTOR_MAIN_DIV = '.p-linked-account-details';
const SELECTOR_LINKED_CHILD = '.p-linked-account-details__linked-child-edit';
const SELECTOR_REMOVE_MODAL = '#remove-player';
const SELECTOR_REMOVE_PLAYER_BUTTON_ACTION = '.js-remove-player';
const SELECTOR_REMOVE_PLAYER_BUTTON = '.lta-modal-remove-child-button';
const SELCTOR_EDIT_PLAYER = '.lta-modal-edit-child-button';

const CLICK_EVENT = 'click';

class LinkedChildAccountsDetails {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_MAIN_DIV);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}
	get playersData() {
		return this._playersData;
	}
	set playersData(data) {
		this._playersData = data;
		if (this._playersData.length > 0) {
			this.renderPlayerList(data);
		}
	}
	init() {
		const removeChildModalElement = SelectorEngine.findOne(SELECTOR_REMOVE_MODAL, this._wrapper);
		this.linkedChildAccount = SelectorEngine.findOne(SELECTOR_LINKED_CHILD, this._wrapper);
		this.navigationBackButtons = SelectorEngine.find('.js-account-edit-back', this._wrapper);
		this.removeModalExitButtons = SelectorEngine.find('.js-lookup-cancel', removeChildModalElement);
		this.removeChildActionButton = SelectorEngine.findOne(
			SELECTOR_REMOVE_PLAYER_BUTTON_ACTION,
			removeChildModalElement
		);
		this.removeChildModal = new Modal(removeChildModalElement);

		this.editChildUrl = Manipulator.getDataAttribute(this._wrapper, 'editChildUrl');

		EventHandler.on(this.removeChildActionButton, CLICK_EVENT, (event) => {
			this.removePlayer(this.playerID, event);
		});

		for (const button of this.removeModalExitButtons) {
			EventHandler.on(button, CLICK_EVENT, () => {
				this.removeChildModal.hide();
			});
		}

		for (const button of this.navigationBackButtons) {
			EventHandler.on(button, CLICK_EVENT, (event) => {
				this.goToUrl(event);
			});
		}
		this.fetchPlayersList();
	}
	async fetchPlayersList() {
		try {
			const url = `/api/player/getplayers`;
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { playerDetails, error } = response;
			if (playerDetails) {
				this.playersData = [...playerDetails];
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
	async removePlayer(playerID, event) {
		try {
			const url = `/api/player/remove-player`;
			const response = await Request.delete(
				url,
				{
					playerId: playerID
				},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { error } = response;
			if (!error.hasError) {
				this.removeChildModal.hide();
				this.goToUrl(event);
			} else {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
	renderPlayerList(playerData) {
		this.linkedChildAccount.innerHTML = playerData.map((item, index) => this.renderPlayerData(item, index)).join('');
		this.removeChildPlayerButtons = SelectorEngine.find(SELECTOR_REMOVE_PLAYER_BUTTON, this.linkedChildAccount);
		this.editChildPlayerButtons = SelectorEngine.find(SELCTOR_EDIT_PLAYER, this.linkedChildAccount);
		for (const button of this.removeChildPlayerButtons) {
			EventHandler.on(button, CLICK_EVENT, (event) => {
				this.playerID = Manipulator.getDataAttribute(event.target, 'playerId');
				this.removeChildModal.show();
			});
		}
		for (const button of this.editChildPlayerButtons) {
			EventHandler.on(button, CLICK_EVENT, (event) => {
				this.goToUrl(event);
			});
		}
	}
	renderPlayerData(playerItem, index) {
		return `<div> 	
			<div class="u-body2 u-text-grey-ui-mid u-mb-1 u-mt-2">Child ${index + 1}</div>
				<div class="u-bg-background-blue u-px-3 u-py-2 u-rounded u-body2 u-text-grey-dark">
					<div><b>${playerItem.firstName} ${playerItem.lastName}</b></div>
					<div>Age: ${this.getAge(playerItem.dateOfBirth)}<div>
					<div>${playerItem.gender}</div>
				</div>
			</div>
			<div class="u-pt-2 u-hstack">
				<button 
					type="button" 
					class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-modal-edit-child-button" 
					data-target="${this.editChildUrl}?playerId=${playerItem.id}">
						<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0 " width="1.5em" height="1.5em" fill="currentColor" alt="pencil-fill" aria-hidden="true">
							<use xlink:href="/static/images/icons/lta-icons.svg#pencil-fill"></use>
						</svg>
						Edit details
				</button>
			</div>
		</div>`;
	}
	getAge(dateString) {
		const dateObject = dayjs(new Date());
		return dateObject.diff(dayjs(dateString), 'year');
	}
	goToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalLinkedChildAccountsDetails = new LinkedChildAccountsDetails();
export default globalLinkedChildAccountsDetails;
